import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'content'
  ]

  toggle(e) {
    this.contentTarget.classList.toggle('hidden')
  }
}
